import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTime = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 17,
	viewBox: "0 0 16 17",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			opacity: .4,
			d: "M6.10352e-05 8.16667C6.10352e-05 10.3326 0.840466 12.4098 2.3364 13.9414C3.83233 15.4729 5.86124 16.3333 7.97681 16.3333C10.0924 16.3333 12.1213 15.4729 13.6172 13.9414C15.1131 12.4098 15.9535 10.3326 15.9535 8.16667C15.9535 6.00073 15.1131 3.92351 13.6172 2.39196C12.1213 0.860414 10.0924 0 7.97681 0C5.86124 0 3.83233 0.860414 2.3364 2.39196C0.840466 3.92351 6.10352e-05 6.00073 6.10352e-05 8.16667ZM7.22899 3.82812C7.2321 3.40065 7.5655 3.0625 7.97681 3.0625C8.18246 3.0625 8.36941 3.14863 8.50651 3.28581C8.57506 3.35599 8.62803 3.43893 8.66542 3.52825C8.68412 3.57292 8.6997 3.62077 8.70905 3.67181C8.71528 3.69733 8.71839 3.72285 8.72151 3.74837C8.72462 3.77389 8.72462 3.79941 8.72462 3.82812C8.72462 5.13607 8.72462 6.4472 8.72462 7.75833L11.3825 9.57031C11.5975 9.71706 11.7159 9.9595 11.7159 10.2083C11.7159 10.3551 11.6754 10.5018 11.5913 10.6326C11.4479 10.8527 11.2111 10.974 10.9681 10.974C10.8248 10.974 10.6814 10.9325 10.5537 10.8464C9.55657 10.1669 8.55948 9.48418 7.56239 8.80469C7.35362 8.66113 7.22899 8.42187 7.22899 8.16667C7.22899 6.72155 7.22899 5.27324 7.22899 3.82812Z",
			fill: "url(#paint0_linear_7940_104548)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.97682 3.0625C7.56241 3.0625 7.229 3.40384 7.229 3.82812V8.16667C7.229 8.42187 7.35364 8.66113 7.56241 8.80469L10.5537 10.8464C10.8964 11.0824 11.3607 10.9867 11.5913 10.6326C11.8219 10.2785 11.7284 9.80638 11.3825 9.57031L8.72464 7.75833V3.82812C8.72464 3.40384 8.39124 3.0625 7.97682 3.0625Z",
			fill: "url(#paint1_linear_7940_104548)"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_7940_104548",
			x1: 610352e-10,
			y1: 8.16667,
			x2: 15.9535,
			y2: 8.16667,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#1D7FB6" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#01D5AB"
			})]
		}), /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint1_linear_7940_104548",
			x1: 7.229,
			y1: 7.01917,
			x2: 11.7178,
			y2: 7.01917,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#1D7FB6" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#01D5AB"
			})]
		})] })
	]
});
export { SvgTime as ReactComponent };
